import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a button based on type, according to
 * traditional industry standards:
 *
 * - primary
 * - danger
 * - success
 * - approve
 * @TODO
 * - disabled
 * - inverse (true/false)
 */
export default class Button extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const colorPicker = () => {
      switch (this.props.type) {
        case 'approve':
          return 'btn-approve';

        case 'primary':
          return 'btn-primary';

        case 'danger':
          return 'btn-danger';

        default:
          return 'btn-primary';
      }
    };

    const color = colorPicker();

    return (
      <button className={`btn ${color}`} onClick={this.props.action}>
        {this.props.children}
        {this.props.text}
      </button>
    );
  }
}

Button.propTypes = {
  action: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  inverse: PropTypes.bool,
};

Button.defaultProps = {
  action: null,
  type: 'primary',
  disabled: false,
  inverse: false,
  text: '',
};
